import {useNavigate, useLocation, Link} from "react-router-dom";
import React, {useState, useEffect, useRef} from "react";
import OtpInput from "./OtpInput";
import  {search_golfer, verify_golfer, update_hs_cart_stage,resend_code} from "../API/APICalls";
import {normalizeInput, normalizeDate, calculate_age, isvalid_mdy, normalizeUSDate} from './functions';
import ReCAPTCHA from 'react-google-recaptcha';

export default function VerifyOTP(){

    const navigate = useNavigate();
    const location = useLocation();


    const [otp, setOtp] = useState('');
    const onChange = (value: string) => setOtp(value);
    const [resendError, setResendError] = useState(false);

    const zipsearch = location.state.zipcode || '';
    const agadata = location.state.aga;
    const golferdata = location.state.inputs;
    const clubs = location.state.clubs;
    const propUsed = location.state.propertyUsed || '';
    const [inputs, setInputs] = useState({firstname: golferdata.firstname || '', lastname: golferdata.lastname, phone: golferdata.phone ||'', email: golferdata.email, dob: golferdata.dob ||'' , sex: golferdata.sex|| '', address: golferdata.address || '', address2:  golferdata.address2 || '', city: golferdata.city || '', state:agadata[0].state, zip: agadata[0].zipcode ||'', contact: golferdata.contact || golferdata.contact_guid || '', handicapID: golferdata.handicapID || ''});
    const [zipcode, setZipcode] = useState(zipsearch);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');


    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    const handleCaptchaChange = (token: string | null) => {
        setIsCaptchaVerified(!!token);
    };


    const resetCaptcha = () => {
        recaptchaRef.current?.reset();
        setIsCaptchaVerified(false);
      };

      const handleFadeOut = () => {
        setResendError(true);
        setTimeout(() => {
            setResendError(false);
         
        }, 5000); 
      };


    const handleResend = async (event: React.FormEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        setIsLoading(true);
        
        const sentCode = true;

        if (sentCode)
        {
            const response2 = await resend_code(inputs, agadata[0].aga_id, agadata);

       //     console.log(JSON.parse(response2 || '').result.properties.contact_guid)
            
            setInputs({... inputs, "contact": JSON.parse(response2 || '').result.properties.contact_guid });
            
            setResendError(true);
            handleFadeOut();
            setIsLoading(false);
        } else {
            setResendError(false);
        
        }

        
        


    }
    function formatDateAndAddDays(date:any, daysToAdd:any) {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + daysToAdd);
      
        const dd = newDate.getDate().toString().padStart(2, '0');
        const mm = date.toLocaleString('default', { month: 'long' });
        const yyyy = newDate.getFullYear();
      
        return `${mm}, ${dd} ${yyyy}`;
      }
    
    
    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
        
        let verifyField = "verify";

        const response = await verify_golfer(verifyField, otp, inputs, propUsed, agadata);


       // console.log(response);


        if (JSON.parse(response || '').guardian && JSON.parse(response || '').propertyUsed == "email")
        {
            setIsLoading(false);
            setIsCaptchaVerified(false);
            setError('Re-enter the information and try again.');
        } else if ((JSON.parse(response || '').guardian && JSON.parse(response || '').propertyUsed=="email") || JSON.parse(response || '').golfers?.is_under_13) {

            setIsLoading(false);
            setIsCaptchaVerified(false);
            setError("Re-enter the information and try again.");
        
        } else if (JSON.parse(response || '').golfers?.status === "Archived") {

            setIsLoading(false);
            setError("Re-enter the information and try again.");
            setIsCaptchaVerified(false);
        } else if ((JSON.parse(response || '').club_affiliations?.days <= 14 && JSON.parse(response || '').club_affiliations?.display == "Active"))
        {
            
            inputs.contact = JSON.parse(response || '').hs_contact_id;
            inputs.handicapID = JSON.parse(response || '').golfers?.ghin;
            inputs.firstname = JSON.parse(response || '').golfers.first_name;
            inputs.lastname = JSON.parse(response || '').golfers.last_name;
            inputs.phone = JSON.parse(response || '').golfers.phone_number;
            inputs.email = JSON.parse(response || '').golfers.email;
            inputs.dob = JSON.parse(response || '').golfers.date_of_birth;
            inputs.sex = JSON.parse(response || '').golfers.gender;
            inputs.address = JSON.parse(response || '').golfers.street_1;
            inputs.address2 = JSON.parse(response || '').golfers.street_2;
            inputs.city = JSON.parse(response || '').golfers.city;
            inputs.state = JSON.parse(response || '').golfers.state;
            inputs.zip = JSON.parse(response || '').golfers.zip;
            inputs.handicapID = JSON.parse(response || '').golfers.ghin;
            
            setIsLoading(false);
            navigate('/personal-info/clubs', {replace:true, state:{zipcode:zipcode, aga:agadata, inputs:inputs}});

        }  else if (JSON.parse(response || '').club_affiliations?.display =="Active" && JSON.parse(response || '').club_affiliations?.days > 14) {
            
            const existingdate = new Date(JSON.parse(response || '').club_affiliations.expire);
            existingdate.setDate(existingdate.getDate() +1);
            existingdate.setHours(0, 0, 0, 0);

            const date = new Date(JSON.parse(response || '').club_affiliations.expire)
            date.setDate(date.getDate() - 13);
            date.setHours(0, 0, 0, 0);
          
            setIsLoading(false);
            setIsCaptchaVerified(false);
            setError(" Your membership is currently paid through "+formatDateAndAddDays(existingdate,0)+". Renewal opens on " + formatDateAndAddDays(date,0)+".");

        } else if ((JSON.parse(response || '').total > 0 && JSON.parse(response || '').globalgolfers.length > 0 && JSON.parse(response || '').globalgolfers[0].is_trial == false))
        {
                 
                inputs.contact = JSON.parse(response || '').hs_contact_id;
                inputs.handicapID = JSON.parse(response || '').globalgolfers[0]?.ghin;
                inputs.firstname = JSON.parse(response || '').globalgolfers[0].first_name;
                inputs.lastname = JSON.parse(response || '').globalgolfers[0].last_name;
                inputs.phone = JSON.parse(response || '').globalgolfers[0].phone_number;
                inputs.email = JSON.parse(response || '').globalgolfers[0].email;
                inputs.dob = JSON.parse(response || '').globalgolfers[0].date_of_birth;
                inputs.sex = JSON.parse(response || '').globalgolfers[0].gender;
                inputs.address = JSON.parse(response || '').globalgolfers[0].street_1;
                inputs.address2 = JSON.parse(response || '').globalgolfers[0].street_2;
                inputs.city = JSON.parse(response || '').globalgolfers[0].city;
                inputs.state = JSON.parse(response || '').globalgolfers[0].state;
                inputs.zip = JSON.parse(response || '').globalgolfers[0].zip;
                
                setIsLoading(false); 

                navigate('/personal-info/clubs', {replace:true, state:{zipcode:zipcode, aga:agadata, inputs:inputs}});
        
        } else if ((JSON.parse(response || '').total > 0 && JSON.parse(response || '').globalgolfers.length > 0 && JSON.parse(response || '').globalgolfers[0].is_trial == true))
            {
                     
                    inputs.contact = JSON.parse(response || '').hs_contact_id;
                    inputs.handicapID = JSON.parse(response || '').globalgolfers[0]?.ghin;
                    inputs.firstname = JSON.parse(response || '').globalgolfers[0].first_name;
                    inputs.lastname = JSON.parse(response || '').globalgolfers[0].last_name;
                    inputs.phone = JSON.parse(response || '').globalgolfers[0].phone_number;
                    inputs.email = JSON.parse(response || '').globalgolfers[0].email;
                    inputs.dob = JSON.parse(response || '').globalgolfers[0].date_of_birth;
                    inputs.sex = JSON.parse(response || '').globalgolfers[0].gender;
                    inputs.address = JSON.parse(response || '').globalgolfers[0].street_1;
                    inputs.address2 = JSON.parse(response || '').globalgolfers[0].street_2;
                    inputs.city = JSON.parse(response || '').globalgolfers[0].city;
                    inputs.state = JSON.parse(response || '').globalgolfers[0].state;
                    inputs.zip = JSON.parse(response || '').globalgolfers[0].zip;
                    
                    setIsLoading(false); 
                    navigate('/personal-info', {replace:true, state:{zipcode:zipcode, aga:agadata, inputs:inputs}});

            }
        
        else if (JSON.parse(response || '').total == 0 && JSON.parse(response || '').results.length == 0)
        {
            setIsLoading(false);
            setIsCaptchaVerified(false);
            setError("Re-enter the information and try again.")
        
        } else {
            
            inputs.contact = JSON.parse(response || '').hs_contact_id;
            inputs.handicapID = JSON.parse(response || '').golfers?.ghin;
            inputs.firstname = JSON.parse(response || '').golfers.first_name;
            inputs.lastname = JSON.parse(response || '').golfers.last_name;
            inputs.phone = JSON.parse(response || '').golfers.phone_number;
            inputs.email = JSON.parse(response || '').golfers.email;
            inputs.dob = JSON.parse(response || '').golfers.date_of_birth;
            inputs.sex = JSON.parse(response || '').golfers.gender;
            inputs.address = JSON.parse(response || '').golfers.street_1;
            inputs.address2 = JSON.parse(response || '').golfers.street_2;
            inputs.city = JSON.parse(response || '').golfers.city;
            inputs.state = JSON.parse(response || '').golfers.state;
            inputs.zip = JSON.parse(response || '').golfers.zip;
         
            navigate('/personal-info', {replace:true, state:{zipcode:zipcode, aga:agadata, inputs:inputs}});
        
        
        }

    }





    useEffect(() => {
        
    }, []);


    return (
        <div className="container page_container mb-5 pb-1">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"><h1 className="fs-1 text-left">Personal Information</h1></div>

          <div className="col-12">
          <form name="Verify Code" autoComplete="off" onSubmit={handleSubmit}> 
            
            
          {isLoading ?
            <div className="loaderWrapper">
                    <div className="loader"></div>
                    </div>
            
            :<>
            <div className="pb-3"><h3>Verify your identity by checking your email for a six-digit code.</h3></div>
          
            <div className="pb-2">
                <p className="fs-6">Didn't get it? <a href="" onClick={handleResend} className="text-secondary">Resend code</a></p>
                {resendError ? <p className="fs-5 text-danger fading-component visible">We have successfully sent you a new six-digit code. Please check your email.</p> : ""}
            </div>
            
           <h3 className="pb-3 text-danger">Please allow up to two minutes to receive your verification code. Keep this tab/browser open while waiting.</h3>

            <OtpInput value={otp} valueLength={6} onChange={onChange} />

            <div className="row pt-4">
            <ReCAPTCHA
        ref={recaptchaRef}
        sitekey="6Le2pp8qAAAAAFDOLCpmqAvWaOI_ZVxcsl9aA9Bc"  // Replace with your actual site key
        onChange={handleCaptchaChange}
      />
      </div>

            <div className="pt-4"><p>For additional inquiries or email updates, contact <a href="mailto:gcsupport@usga.org">USGA.</a></p></div>

           {error ? <h3 className="py-3 text-left text-danger"><i className="bi bi-exclamation-circle"></i> {error} If you're having trouble, contact the <a className='text-danger' href='mailto:gcsupport@usga.org'>USGA</a>.</h3>: ''}

            <div className="mt-4 col-12 col-sm-10 col-md-12 col-lg-12">
                <div className="row">
                <div className="col-12 col-sm-6 order-1 pt-3">
                    <Link replace={true} to="/personal-lookup" state={{zipcode:zipsearch, aga:agadata, inputs:inputs}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                        BACK
                    </Link>
                   
                </div>
                <div className="col-12 col-sm-6 order-sm-1 order-lg-1 pt-3">
                    <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit" disabled={!isCaptchaVerified}>
                        CONTINUE
                    </button>
                </div>
                </div>
            </div>
            </>}
            </form>
            </div>
        </div>
    </div>
    )
}